
<style scoped>
.header {
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  padding-bottom: 20px;
  color: #832c75;
}
.list .item {
  display: flex;
  border-bottom: 1px solid #f8f8f8;
  line-height: 36px;
}
.list .item .left,
.list .item .right {
  flex: 1;
  display: flex;
}
.list .item .left .title,
.list .item .right .title {
  width: 220px !important;
  font-weight: bold;
}
.list .item .left .content,
.list .item .right .content {
  color: #666;
  flex: 1;
}
.box {
  max-height: 70vh;  /* 调整为更合理的高度 */
  overflow-y: auto;
  padding-right: 10px;
}
/* 滚动条样式优化 */
.box::-webkit-scrollbar {
  width: 6px;
}
.box::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
.box::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}
/* 当edition为3时的特殊样式 */
.edition-combined {
  padding-bottom: 20px;
}
</style>
<template>
  <a-modal
    title="详情"
    :visible="visible"
    @cancel="cancel"
    :width="1000"
    :footer="null"
    :bodyStyle="{ maxHeight: '80vh', overflow: 'hidden' }"
  >
    <div class="box" :class="{'edition-combined': data && data.edition === 3}">
      <div class="header">
        <span>基本信息</span>
      </div>
      <div class="base" v-if="data != null">
        <!-- 基本信息 -->
        <baseInfo :data="data" />
      </div>
      <!-- 简版-->
      <!-- 完整版-->
      <div class="header" style="margin-top: 20px">
          <span>社会-情绪	</span>
        </div>
        <div class="list">
          <div class="item">
            <div class="left">
              <div class="title">社会-情绪(SE):</div>
              <div class="content">{{ data.score_se }}</div>
            </div>
          </div>
          
          <div class="item">
            <div class="left">
              <div class="title">显著性水平:</div>
              <div class="content">{{ data.significance_level }}</div>
            </div>
            <div class="right">
              <div class="title">置信区间:</div>
              <div class="content">{{ data.confidence_probability }}%</div>
            </div>
          </div>
          <div class="item">
            <div class="left">
              <div class="title">最高掌握阶段:</div>
              <div class="content">
                <span v-if="data.highest_stage === '1'">还未掌握第一阶段</span>
                <span v-if="data.highest_stage === '2'">第1阶段</span>
                <span v-if="data.highest_stage === '3'">第2阶段</span>
                <span v-if="data.highest_stage === '4'">第3阶段</span>
                <span v-if="data.highest_stage === '5'">第4(a)阶段</span>
                <span v-if="data.highest_stage === '6'">第4(b)阶段</span>
                <span v-if="data.highest_stage === '7'">第5(a)阶段</span>
                <span v-if="data.highest_stage === '8'">第5(b)阶段</span>
                <span v-if="data.highest_stage === '9'">第6阶段</span>
              </div>
            </div>
          </div>
        </div>
        <div class="header" style="margin-top: 20px">
          <span>社会-情绪	</span>
        </div>
        <div class="list">
          <div class="item">
            <div class="left">
              <div class="title">第1-8题原始总分:</div>
              <div class="content">{{ data.score_original }}</div>
            </div>
          </div>
          <div class="item">
            <div class="left">
              <div class="title">无法判断/猜测的题目数量:</div>
              <div class="content">{{ data.guess_se }}</div>
            </div>
          </div>
        </div>
        <div v-if="hasDetailScores">
          <div class="header" style="margin-top: 20px">
            <span>详细题目分数</span>
          </div>
          <bayley-score-detail :value="detailScores" readonly />
        </div>
        
      </div>
    </div>
  </a-modal>
</template>

<script>
import { Detail } from "../../commonApi";
import BayleyScoreDetail from "../bayley-score-detail";
export default {
  components: { BayleyScoreDetail },
  props: {
    item: [Object],
    detailVisible: [Boolean],
  },
  watch: {
    item: {
      handler: function (e) {
        this.data = e;
        this.id = e.id;
        if (e.edition == 1) {
          this.title = "2:6 - 3:11";
        } else if (e.edition == 2) {
          this.title = "4:0 - 6:11";
        }
      },
      immediate: true,
      deep: true,
    },
    detailVisible: {
      handler: function (e) {
        this.visible = e;
        if (this.visible) {
          this.getDetail();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    detailScores() {
      const scores = this.data && this.data.detail_scores;
      if (scores && typeof scores === "object") return scores;
      if (typeof scores === "string" && scores) {
        try {
          return JSON.parse(scores);
        } catch (e) {
          return {};
        }
      }
      return {};
    },
    hasDetailScores() {
      return (
        this.data &&
        String(this.data.detail_score_enabled) === "1" &&
        Object.keys(this.detailScores).length > 0
      );
    },
  },
  data() {
    return {
      title: "",
      visible: true,
      id: "",
      data: null,
      type: "",
    };
  },
  created() {},
  methods: {
    async getDetail() {
      const res = await Detail({ id: this.id });
      if (res && res.code == 0) {
        this.data = res.bayleyAssessment;
      }
    },
    cancel() {
      this.visible = false;
      this.$emit("detailCancel");
    },
  },
};
</script>
